import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import AccessibilityBar from "@/components/AccessibilityBar";
import Landing from "@/components/Landing";
import ComingSoon from "@/components/ComingSoon";
import LensApp from "@/components/LensApp";
import { PaymentSuccess, PaymentCancel } from "@/components/PaymentResult";

const DEFAULT_A11Y = { scale: 1, hc: false, dyslexic: false };

function Home() {
  const [params] = useSearchParams();
  const checkout = params.get("checkout");
  if (checkout === "success") return <PaymentSuccess sessionId={params.get("session_id")} />;
  if (checkout === "cancel") return <PaymentCancel />;
  if (params.get("view") === "app") return <LensApp />;
  if (params.get("view") === "coming-soon") return <ComingSoon />;
  return <Landing />;
}

function App() {
  const [a11y, setA11y] = useState(() => {
    try {
      return { ...DEFAULT_A11Y, ...JSON.parse(localStorage.getItem("vl-a11y") || "{}") };
    } catch {
      return DEFAULT_A11Y;
    }
  });

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.style.fontSize = `${16 * a11y.scale}px`;
    root.classList.toggle("hc", a11y.hc);
    root.classList.toggle("dyslexic", a11y.dyslexic);
    localStorage.setItem("vl-a11y", JSON.stringify(a11y));
  }, [a11y]);

  return (
    <div className="min-h-screen overflow-x-clip bg-[#071A35] text-slate-100">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <AccessibilityBar a11y={a11y} setA11y={setA11y} />
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
